import mock from 'utils/mock';

mock.onGet('/api/charge').reply(200, {
  total: [
    { name: 'Total Charges', amount: '650,000.00' },
    { name: 'Total Fee', amount: '6,500.00' }
  ],
  data: [
    {
      device: 'E-commerce',
      type: 'TQR',
      invoiceId: '5dc234f89A',
      amount: 60,
      created: '2020-01-11T18:00:00.549Z',
      paid: '2020-01-11T18:02:00.549Z',
      ref1: '5dc234f89A',
      ref2: '14000198D79F',
      ref3: 'FINS',
      note: 'Food',
      status: 'Paid'
    },
    {
      device: 'BNK48',
      type: 'TQR',
      invoiceId: '5dc234f89B',
      amount: 60,
      created: '2020-01-11T17:05:00.549Z',
      paid: '',
      ref1: '5dc234f89B',
      ref2: '4D00010D402C',
      ref3: 'FINS',
      note: 'Ticket',
      status: 'Paid'
    },
    {
      device: 'Bottle',
      type: 'QRCS',
      invoiceId: '5dc234f89C',
      amount: 60,
      created: '2020-01-11T16:10:00.549Z',
      paid: '',
      ref1: '5dc234f89C',
      ref2: 'D800016A163A',
      ref3: 'FINS',
      note: 'Bottle',
      status: 'Reject'
    },
    {
      device: 'Cosmetic',
      type: 'Alipay',
      invoiceId: '5dc234f89D',
      amount: 60,
      created: '2020-01-11T15:15:00.549Z',
      paid: '',
      ref1: '5dc234f89D',
      ref2: '8500018AC86B',
      ref3: 'FINS',
      note: 'Cosmetic',
      status: 'Paid'
    },
    {
      device: 'Locker',
      type: 'Wechat Pay',
      invoiceId: '5dc234f89E',
      amount: 60,
      created: '2020-01-11T14:00:00.549Z',
      paid: '',
      ref1: '5dc234f89E',
      ref2: '600001A3C629',
      ref3: 'FINS',
      note: 'Service',
      status: 'Paid'
    }
  ]
});
